/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Now_HintInputs */

const vi_irrigation_run_now_hint = /** @type {(inputs: Irrigation_Run_Now_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bơm bật ngay và tự tắt khi hết thời lượng.`)
};

/**

* @param {Irrigation_Run_Now_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_now_hint = /** @type {((inputs?: Irrigation_Run_Now_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Now_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_now_hint(inputs)
});